module.exports = __webpack_public_path__ + "media/src/images/viewbtn/normal-on-aebe5c21819d010f760cc9276d404042.png";